var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenhead2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 43,
    viewBox: "0 0 41 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Currency"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.6661 18.8023C37.6661 9.26663 29.9715 1.53906 20.4766 1.53906C10.9817 1.53906 3.28711 9.26663 3.28711 18.8023V24.113H37.6661V18.8023Z",
    fill: "url(#paint0_linear_8056_42331)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.4766 6.84978V1.53906",
    stroke: "#EAAD42",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.39453 14.2189V8.9082",
    stroke: "#EAAD42",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M34.5586 14.2189V8.9082",
    stroke: "#EAAD42",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.4336 8.36247V3.05176",
    stroke: "#EAAD42",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M27.5195 8.36247V3.05176",
    stroke: "#EAAD42",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M37.6661 18.8023C37.6661 9.26663 29.9715 1.53906 20.4766 1.53906C10.9817 1.53906 3.28711 9.26663 3.28711 18.8023V24.113H37.6661V18.8023Z",
    stroke: "#EAAD42",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M20.4766 41.3761C29.9701 41.3761 37.6661 33.6471 37.6661 24.1128C37.6661 14.5786 29.9701 6.84961 20.4766 6.84961C10.9831 6.84961 3.28711 14.5786 3.28711 24.1128C3.28711 33.6471 10.9831 41.3761 20.4766 41.3761Z",
    fill: "#FFD45A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M18.0799 17.8393L20.4729 19.2612L22.8749 17.8393L20.4729 16.4173L18.0799 17.8393ZM12.2445 24.1131L9.85609 22.6957V30.4051L16.3655 34.2393V31.3954L12.2581 28.9695L12.2445 24.1131ZM12.2445 19.2567L14.6465 17.8347L12.2445 16.4128L9.85156 17.8347V20.665L12.2445 22.0869V19.2567ZM13.9725 27.961L16.3655 29.3693V26.539L13.9725 25.1171V27.961ZM28.6967 19.2567V22.0869L31.0987 20.665V17.8347L28.6967 16.4128L26.3037 17.8347L28.6967 19.2567ZM28.7102 24.1131L28.6967 28.9695L24.5893 31.3954V34.2393L31.0987 30.4051V22.6957L28.7057 24.1176L28.7102 24.1131ZM18.0799 32.413V35.2433L20.4729 36.6653L22.8749 35.2433V32.413L20.4729 33.835L18.0799 32.413ZM26.9822 25.1216L24.5893 26.5436V29.3738L26.9822 27.9655V25.1216ZM20.4729 14.3957L24.5938 16.8353L26.9868 15.4133L20.4774 11.5654L13.977 15.4133L16.37 16.8353L20.4774 14.3957H20.4729ZM26.9822 20.2652H26.9913L24.5893 18.8432L20.4683 21.2828L16.3745 18.8432L13.9725 20.2652V23.1091L18.0935 25.535V30.4005L20.4864 31.8088L22.8794 30.4005V25.535L27.0003 23.1091L26.9868 20.2652H26.9822Z",
    fill: "#FFFAEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.5,
    d: "M20.4762 37.3921C27.7787 37.3921 33.6986 31.4469 33.6986 24.113C33.6986 16.7792 27.7787 10.834 20.4762 10.834C13.1737 10.834 7.25391 16.7792 7.25391 24.113C7.25391 31.4469 13.1737 37.3921 20.4762 37.3921Z",
    stroke: "#EABF53",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    opacity: 0.4,
    d: "M35.4548 15.6538L14.3705 40.2311C16.2704 40.958 18.3241 41.376 20.4819 41.376C21.0609 41.376 21.6308 41.3442 22.1918 41.2896L37.6306 23.295C37.4994 20.5283 36.735 17.9343 35.4593 15.6538H35.4548ZM25.2633 7.54004L4.87109 31.3133C5.83461 33.4122 7.20072 35.2793 8.87443 36.8194L31.2841 10.6974C29.529 9.2709 27.4888 8.18968 25.2633 7.54458V7.54004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M20.4766 41.3761C29.9701 41.3761 37.6661 33.6471 37.6661 24.1128C37.6661 14.5786 29.9701 6.84961 20.4766 6.84961C10.9831 6.84961 3.28711 14.5786 3.28711 24.1128C3.28711 33.6471 10.9831 41.3761 20.4766 41.3761Z",
    stroke: "#EAAD42",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8056_42331",
    x1: 3.28711,
    y1: 12.8283,
    x2: 37.6661,
    y2: 12.8283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD45A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenhead2);
export default __webpack_public_path__ + "static/media/tokenhead2.51dabdd765d53b072185de4b7756c89e.svg";
export { ForwardRef as ReactComponent };